var _path, _path2, _g, _g2, _circle, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_134441)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06829 22.8641C1.76269 21.7235 1.92267 20.5083 2.51305 19.4858C3.10343 18.4632 4.07583 17.717 5.21636 17.4114L33.3119 9.88327C34.4524 9.57767 35.6676 9.73765 36.6902 10.328C37.7128 10.9184 38.4589 11.8908 38.7645 13.0313L46.2927 41.1269C46.5983 42.2674 46.4383 43.4826 45.8479 44.5052C45.2576 45.5277 44.2852 46.2739 43.1446 46.5795L15.0491 54.1077C13.9086 54.4133 12.6934 54.2533 11.6708 53.6629C10.6482 53.0725 9.90207 52.1001 9.59647 50.9596L2.06829 22.8641Z",
    fill: "#AE9AFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3074_134441",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 20,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3565 20.5619L17.4456 22.6816C13.9009 23.6314 11.7973 27.2749 12.7471 30.8196L14.8668 38.7305C15.8166 42.2752 19.4601 44.3788 23.0048 43.429L30.9157 41.3093C34.4604 40.3595 36.564 36.7159 35.6142 33.1712L33.4945 25.2604C32.5447 21.7157 28.9012 19.6121 25.3565 20.5619Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3074_134441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2635 21.4666L17.9787 23.4185C14.7145 24.2932 12.7774 27.6483 13.652 30.9125L15.604 38.1973C16.4786 41.4615 19.8338 43.3986 23.098 42.524L30.3828 40.572C33.647 39.6974 35.5841 36.3422 34.7095 33.0781L32.7575 25.7932C31.8829 22.529 28.5277 20.5919 25.2635 21.4666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4026 21.6255C22.7287 21.2701 24.0521 20.9043 25.3811 20.5594C26.9028 20.1729 28.5118 20.3327 29.9277 21.0111C31.3435 21.6895 32.4763 22.8434 33.1285 24.2716C33.2874 24.6197 33.4174 24.9802 33.5173 25.3496C34.2152 27.9214 34.8971 30.4991 35.5898 33.0692C35.9717 34.4806 35.883 35.9781 35.3371 37.3346C34.7912 38.6911 33.8178 39.8326 32.5646 40.586C32.0389 40.9026 31.4711 41.1433 30.878 41.3011C28.2615 42.0022 25.653 42.7363 23.0252 43.3957C20.4768 44.0345 18.2624 43.3616 16.427 41.4882C15.6562 40.7012 15.147 39.7474 14.8605 38.6811C14.1606 36.069 13.4528 33.4663 12.7634 30.8546C12.2881 29.0478 12.538 27.3267 13.4848 25.7164C14.2172 24.4579 15.3482 23.4793 16.699 22.9354C16.9683 22.8263 17.2444 22.735 17.5256 22.6619C18.8171 22.3143 20.1092 21.972 21.4026 21.6255ZM26.2635 39.7667L30.054 38.7511C30.2108 38.7128 30.3655 38.6663 30.5174 38.6117C31.3845 38.2909 32.1129 37.6783 32.5776 36.8791C33.1236 35.9465 33.2907 34.9402 33.0173 33.896C32.3311 31.2723 31.6133 28.6562 30.9161 26.0362C30.7492 25.3674 30.4036 24.7566 29.9163 24.2692C28.8198 23.1832 27.5066 22.7871 26.012 23.1764C23.3892 23.8544 20.7768 24.5712 18.1609 25.2745C18.0009 25.3167 17.8442 25.3704 17.6921 25.4353C16.7941 25.8029 16.0634 26.4889 15.6398 27.3618C15.2085 28.2357 15.0896 29.1563 15.3427 30.1011C16.0395 32.7273 16.7426 35.3513 17.452 37.9731C17.5071 38.1753 17.5767 38.3731 17.6603 38.5652C18.4215 40.3314 20.4555 41.319 22.3118 40.8256C23.6302 40.4739 24.9474 40.121 26.2635 39.7667Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5226 30.0973L21.4505 33.6785L19.1407 32.3569L19.887 31.085L18.5928 30.3392L19.9305 28.0234L23.5226 30.0973Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7121 28.6937L26.6308 32.291L24.333 30.9694L25.0807 29.694L23.7818 28.9541L25.1257 26.6231L28.7121 28.6937Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5368 37.0493C25.1845 37.1224 24.8234 37.1435 24.4649 37.1117C23.6606 37.0593 22.8594 37.0156 22.057 36.9675C21.5043 36.9348 21.1136 36.5363 21.1282 36.0237C21.1419 35.4601 21.6177 35.0654 22.1908 35.1295C22.8865 35.2062 23.5817 35.2871 24.2787 35.3539C24.8394 35.4073 25.3995 35.2466 25.8467 34.9041C26.396 34.5034 26.9436 34.0991 27.493 33.6983C27.5986 33.619 27.7201 33.5632 27.8491 33.5349C27.9795 33.5064 28.1146 33.5071 28.2448 33.5369C28.375 33.5659 28.4973 33.6229 28.6031 33.704C28.7088 33.7856 28.7956 33.8889 28.8579 34.0069C28.967 34.2107 28.9949 34.4481 28.9361 34.6716C28.8773 34.8952 28.736 35.0881 28.5408 35.2117C28.0541 35.5389 27.5631 35.8617 27.0711 36.1839C26.7272 36.408 26.3841 36.6319 26.0317 36.8423C25.8713 36.9217 25.706 36.9908 25.5368 37.0493Z",
    fill: "#222222"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3074_134441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9556 6.85558C45.546 5.83302 46.5184 5.08686 47.6589 4.78126C48.7994 4.47566 50.0147 4.63564 51.0372 5.22602L76.227 19.7693C77.2496 20.3597 77.9957 21.3321 78.3013 22.4727C78.6069 23.6132 78.4469 24.8284 77.8566 25.8509L63.3132 51.0407C62.7229 52.0633 61.7504 52.8094 60.6099 53.115C59.4694 53.4207 58.2542 53.2607 57.2316 52.6703L32.0419 38.127C31.0193 37.5366 30.2731 36.5642 29.9675 35.4237C29.6619 34.2831 29.8219 33.0679 30.4123 32.0454L44.9556 6.85558Z",
    fill: "#C4B6FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.0821,
    cy: 28.9232,
    r: 10,
    transform: "rotate(30 54.0821 28.9232)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0821 20.2629C54.3017 17.5029 48.1819 19.1427 45.4219 23.9232C42.6619 28.7037 44.3017 34.8234 49.0821 37.5834C53.8626 40.3434 59.9824 38.7037 62.7424 33.9232C65.5024 29.1427 63.8626 23.0229 59.0821 20.2629ZM49.2511 35.2908C46.0753 32.8914 45.1139 28.4566 47.1539 24.9232C47.4639 24.3863 47.8282 23.9153 48.2308 23.478L49.9841 30.0213L49.4841 30.8873C48.9341 31.8399 49.2635 33.0693 50.2161 33.6193L49.2511 35.2908ZM56.4959 36.541C56.6758 35.7095 56.3249 34.8372 55.5455 34.3872L54.6794 33.8872L56.1794 31.2891C56.4544 30.8128 56.2897 30.1981 55.8134 29.9231L50.6173 26.9231L51.6173 25.1911L53.3493 26.1911C53.8256 26.4661 54.4403 26.3013 54.7153 25.825L55.7153 24.093L57.4474 25.093C58.4 25.643 59.6294 25.3136 60.1794 24.3609L60.3844 24.0059C62.3269 26.5014 62.6846 30.0219 61.0096 32.9231C59.9696 34.7244 58.3317 35.9612 56.4959 36.541Z",
    fill: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3074_134441",
    x: 24.8164,
    y: 0.629517,
    width: 58.6367,
    height: 58.6372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3074_134441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3074_134441",
    result: "effect2_dropShadow_3074_134441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3074_134441",
    result: "effect3_dropShadow_3074_134441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3074_134441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_134441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9907,
    height: 37.9907,
    fill: "white",
    transform: "translate(0.916016 18.5637) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPlaceholder);
export default __webpack_public_path__ + "static/media/settings-placeholder.01251364ab435852787d2f4b7f928bc2.svg";
export { ForwardRef as ReactComponent };